const getMapData = (data) => {
  let mapPositionsData = [];
  const carNumber = data.number;
  const mapRoute = [];
  const mapRoutes = [];
  const dumpRoutes = [];
  const dump2Routes = [];
  const sandRoutes = [];

  let mapPoints = [];
  let index = 0;

  data.routes.forEach((route) => {
    mapPositionsData = mapPositionsData.concat(route.positions);
  });

  const mapPositionsCount = mapPositionsData.length;

  let prevDistance = 0;

  data.routes.forEach((route, inte) => {
    const _mapPoints = [];

    if (dumpRoutes.length === 0 || dumpRoutes[dumpRoutes.length - 1].length > 0) {
      dumpRoutes.push([]);
    }

    if (dump2Routes.length === 0 || dump2Routes[dump2Routes.length - 1].length > 0) {
      dump2Routes.push([]);
    }

    if (sandRoutes.length === 0 || sandRoutes[sandRoutes.length - 1].length > 0) {
      sandRoutes.push([]);
    }

    route.positions.forEach((item, i) => {
      addDump2Point(dump2Routes, item, i);
      addDumpPoint(dumpRoutes, item, i);
      addSandPoint(sandRoutes, item, i);

      const lastPoint = i > 0 && _mapPoints.length === 0 ? mapPoints[mapPoints.length - 1] : _mapPoints[_mapPoints.length - 1];

      if (!!lastPoint && lastPoint.status === item.status && item.status === 2) {
        // lastPoint.finishIndex = index;
        // lastPoint.finishDate = item.time;
        // lastPoint.location = [item.location.lat, item.location.long];
        // lastPoint.address = item.address;
      } else {
        prevDistance = (prevDistance * 100000 + item.distance * 100000) / 100000;

        _mapPoints.push({
          index: index,
          date: item.time,
          location: [item.location.lat, item.location.long],
          address: "", //item.address, */
          distanceFromStart: prevDistance,
        });
      }

      index++;
    });

    if (mapRoutes.length > 0 && _mapPoints.length > 0) {
      mapRoutes.push([mapRoutes[mapRoutes.length - 1][mapRoutes[mapRoutes.length - 1].length - 1], _mapPoints[0].location]);
    }

    mapRoutes.push(
      _mapPoints.map((x) => {
        return x.location;
      })
    );

    mapPoints = mapPoints.concat(_mapPoints);
  });

  mapPoints.forEach((item) => {
    mapRoute.push(item.location);
  });

  return {
    mapPositionsData,
    mapPositionsCount,
    carNumber,
    mapRoute,
    mapRoutes,
    mapPoints,
    dumpRoutes,
    dump2Routes,
    sandRoutes,
  };
};

function addDumpPoint(dumpRoutes, point, index) {
  const i = dumpRoutes.length - 1;
  const isDump = point.data.DU1 !== undefined && point.data.DU1.toLowerCase() === "true";

  if (isDump) {
    dumpRoutes[i].push([point.location.lat, point.location.long]);
  } else {
    dumpRoutes.push([]);
  }
}

function addDump2Point(dump2Routes, point, index) {
  const i = dump2Routes.length - 1;

  const isDump = point.data.DU2 !== undefined && point.data.DU2.toLowerCase() === "true";

  if (isDump) {
    dump2Routes[i].push([point.location.lat, point.location.long]);
  } else {
    dump2Routes.push([]);
  }
}

function addSandPoint(sandRoutes, point, index) {
  const i = sandRoutes.length - 1;
  const isSand = point.data.SAND !== undefined && point.data.SAND.toLowerCase() === "true";

  if (isSand) {
    sandRoutes[i].push([point.location.lat, point.location.long]);
  } else {
    sandRoutes.push([]);
  }
}

export default getMapData;
